import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from '../components/Logo';
import '../styles/GenderSelection.css';

const ROLE_DASH = { salon: '/dashboard/salon', admin: '/dashboard/admin', franchisee: '/dashboard/franchisee' };

const GenderSelection = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user && ROLE_DASH[user.role]) {
      navigate(ROLE_DASH[user.role], { replace: true });
    }
  }, [user, navigate]);

  const handleGenderSelect = (gender) => {
    localStorage.setItem('userGenderPreference', gender);
    navigate(`/search/${gender}`);
  };

  return (
    <div className="gender-selection-container">
      <div className="content-wrapper">
        <div className="hero-logo-box">
          <Logo size="large" />
        </div>
        <p className="subtitle">Wybierz kategorię usług, które Cię interesują</p>
        
        <div className="gender-cards">
          <div className="gender-card male" onClick={() => handleGenderSelect('male')}>
            <div className="gender-icon">
              <img src="/images/male.png" alt="Mężczyzna" />
            </div>
            <h2>DLA MĘŻCZYZN</h2>
          </div>

          <div className="gender-card female" onClick={() => handleGenderSelect('female')}>
            <div className="gender-icon">
              <img src="/images/female.png" alt="Kobieta" />
            </div>
            <h2>DLA KOBIET</h2>
          </div>
        </div>
      </div>
      
      <footer className="modern-footer">
        <div className="footer-container">
          <div className="footer-top">
            <div className="footer-brand">
              <h2 className="footer-logo-text">HAIR<span>KUS</span></h2>
              <p className="brand-tagline">Twój salon w zasięgu ręki</p>
              <p className="brand-description">
                Profesjonalne rozwiązania dla branży beauty. 
              </p>
            </div>
            <div className="footer-nav">
              <div className="footer-column">
                <h4>DLA SALONÓW</h4>
                <span className="footer-link" onClick={() => navigate('/register')}>Dołącz do sieci</span>
                <span className="footer-link" onClick={() => navigate('/login')}>Panel salonu</span>
              </div>

              <div className="footer-column">
                <h4>INFORMACJE</h4>
                <p>kontakt@hairkus.pl</p>
                <p>+48 123 456 789</p>
              </div>

              <div className="footer-column">
                <h4>SOCIAL</h4>
                <span className="footer-link">Instagram</span>
                <span className="footer-link">Facebook</span>
              </div>
            </div>
          </div>

          <hr className="footer-divider" />

          <div className="footer-bottom-bar">
            <p className="copyright">&copy; {new Date().getFullYear()} HAIRKUS. Wszelkie prawa zastrzeżone.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default GenderSelection;